<template>
  <el-dialog title="分配套码"
    :visible.sync="visible"
    width="600px"
    @close='handleClose'
    :close-on-press-escape="false">
    <el-form :model="produceInfo"
      :rules="rules"
      ref="ruleForm"
      label-width="120px">
      <el-form-item label="标签类型:">
        {{tagInfo.tagType | tagType()}}
      </el-form-item>
      <el-form-item label="未分配套数:">
        {{tagInfo.notAssignSetCount}}
      </el-form-item>
      <el-form-item label="分配企业:"
        prop="refVendorId">
        <assign-ent-select v-model="produceInfo.refVendorId"
          :option="{tagType: tagInfo.tagType, tagModel: 2 }" />
      </el-form-item>
      <el-form-item label="分配套数:"
        prop="setCount">
        <el-input-number v-model="produceInfo.setCount"
          controls-position="right"
          :min="1"
          :max="tagInfo.notAssignSetCount"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item label="套码起始序号:">
        {{tagInfo.beginSetNo | tagCount()}}
      </el-form-item>
      <el-form-item label="套码结束序号:"
        prop="endSetNo">
        <el-input v-model.number="produceInfo.endSetNo"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
      class="dialog-footer">
      <el-button @click="toggleModal(false)"
        :loading="loading">取 消</el-button>
      <el-button type="primary"
        @click="handleSubmit"
        :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import AssignEntSelect from '@/components/business/assign-ent-select.vue'
export default {
  name: 'distribution-modal',
  components: { AssignEntSelect },
  props: {
    tagInfo: {
      type: Object,
      required: true,
      default () {
        return {
          tagType: '',
          beginSetNo: null
        }
      }
    },
    fetch: {
      type: Function,
      required: true
    }
  },
  data () {
    const validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入套码结束序号'))
      } else if (!Number.isInteger(value) || value < this.tagInfo.beginSetNo) {
        callback(new Error('套码结束序号不能小于套码起始序号'))
      } else if (this.produceInfo.setCount > value - this.tagInfo.beginSetNo + 1) {
        callback(new Error('套码数量应大于等于分配数量'))
      } else if (value - this.tagInfo.beginSetNo + 1 > this.tagInfo.notAssignSetCount) {
        callback(new Error('套码数量不足'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      entList: [],
      visible: false,
      produceInfo: {
        refVendorId: null,
        setCount: '',
        endSetNo: ''
      },
      rules: {
        refVendorId: [{ required: true, message: '请选择分配企业', trigger: 'change' }],
        setCount: [{ required: true, message: '请输入分配数量', trigger: 'blur' }],
        endSetNo: [{ required: true, validator: validateCode, trigger: 'blur' }]
      }
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('label/assignpoolsetsegment', {
            payload: {
              ...this.produceInfo,
              setSegId: this.tagInfo.setSegId,
              beginSetNo: this.tagInfo.beginSetNo
            },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
              this.fetch()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
